// app/javascript/i18n/index.ts
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en.json'
import hi from './hi.json'

i18n
  .use(initReactI18next)
  .init({
    lng: document.documentElement.lang || 'en',
    fallbackLng: 'en',
    resources: {
      en: { translation: en },
      hi: { translation: hi },
    },
    interpolation: { escapeValue: false },
  })

export default i18n
